<template>
	<Head>
		<Title>StocksToTrade - About</Title>
		<Meta
			name="description"
			content="Since 2009, StocksToTrade has helped new and seasoned traders make consistently profitable trades.  Try us today for only $7.00"
		/>
		<Meta
			property="og:description"
			content="Since 2009, StocksToTrade has helped new and seasoned traders make consistently profitable trades.  Try us today for only $7.00"
		/>

		<Meta
			property="og:title"
			content="StocksToTrade - About"
		/>

		<Link
			:href="current_hostname.slice(0, -1) + '/about/'"
			rel="canonical"
		/>
		<Meta
			:content="current_hostname.slice(0, -1) + '/about/'"
			property="og:url"
		/>
	</Head>
	<about-hero-section />

	<gradient-box-component
		title="Our Mission"
		paragraph="Bringing state-of-the-art technology, 
                        powerful proprietary algorithms and AI-enhanced tools, 
                        and savvy trading strategies together to help day traders master the markets."
	/>
	<NonInteractiveCarousel />
	<Forward-Thinking />
	<NonInteractiveCarousel2 />
	<what-we-deliver-section />

	<section class="section-gradient">
		<TeamTradersList />
	</section>
	<testimonialSlider />
</template>
<script setup>
const { current_hostname } = useRuntimeConfig().public;

const fetchData = async (hostname) => {
	try {
		const data = await $fetch(hostname + "wp-json/wp/v2/pages/1236");
		return data;
	} catch (e) {
		console.error(e);
	}
};

const aboutDataKey = "about-page-data";

await useAsyncData(
	aboutDataKey,
	async ({ $config }) => {
		try {
			let payload = {
				post: null,
				metadata: null
			};

			const response = await fetchData($config.public["hostname"]);

			// const schema = schemaMaker(
			// 	response,
			// 	config.public["current_hostname"],
			// 	$categories
			// );

			const { yoast_head_json: metadata, ...rest } = response;

			payload = {
				post: rest,
				metadata
				// schema: {
				// 	"@context": "https://schema.org",
				// 	"@graph": schema
				// },
				// type: element.type
			};

			return { ...payload };
		} catch (error) {
			if (error.cause.statusCode === 404) {
				throw createError({
					statusCode: 404,
					fatal: true
				});
			} else {
				throw createError({
					statusCode: 500,
					statusMessage: error,
					fatal: true
				});
			}
		}
	}
);

onMounted(() => {
	// fetchData();
	// scriptElement = document.createElement("script");
	// scriptElement.innerHTML = page.yoast_meta[14].content;
	// scriptElement.classList.add(`saswp-schema-markup-output`);
	// scriptElement.type = "application/ld+json";
	// document.head.appendChild(scriptElement);
});
</script>
<style scoped lang="scss"></style>
